import React, { FC, ReactElement, ReactNode } from 'react';
import classNames from 'classnames';

import Button, {
  BUTTON_TYPES,
  BUTTON_SIZES,
  BUTTON_WIDTHS
} from 'buyside/components/presentation/Button/button';
import StripeFailure from 'buyside/components/presentation/Stripe/StripeFailure';
import SubscribeCardHeader from './SubscribeCardHeader';
import useMakeStripeCheckout from 'buyside/components/presentation/Stripe/useMakeStripeCheckout';

import { PaymentPlanValues, PriceType, STRIPE_PLANS } from 'interfaces/payment/plans';
export interface SubscribeCardProps {
  children?: ReactNode;
  isCurrentTier: boolean;
  isRetail: boolean;
  price: number;
  stripePlan: PaymentPlanValues;
  title: string;
  type: PriceType;
}

import styles from './subscribeCardStyles.scss';

const SubscribeCard: FC<SubscribeCardProps> = ({
  children,
  isCurrentTier = false,
  isRetail,
  price,
  stripePlan,
  title,
  type
}): ReactElement => {
  const { onSubmit, loading, error } = useMakeStripeCheckout(stripePlan);

  return (
    <div className={classNames(styles.modal, isRetail ? styles.retail : '')}>
      <SubscribeCardHeader
        isCurrentTier={isCurrentTier}
        price={price}
        subscriptionTier={title}
        type={type}
      />
      {children}
      <div className={styles.subscribeButton}>
        <Button
          isLoading={loading}
          onClick={(): void => onSubmit()}
          size={BUTTON_SIZES.LARGE}
          text={`Choose This ${
            [STRIPE_PLANS.retailTier2, STRIPE_PLANS.retailTier3].includes(stripePlan)
              ? 'Package'
              : 'Plan'
          }`}
          type={BUTTON_TYPES.PRIMARY}
          width={BUTTON_WIDTHS.WIDE}
        />
        {error && <StripeFailure plan={stripePlan} />}
      </div>
    </div>
  );
};

export default SubscribeCard;
